

import { defineComponent, ref, onMounted, reactive, onUnmounted } from "vue"
import AdView from '@/components/ad.vue'
interface SuccessState {
    shortUrl: string;
    isShow: boolean;
    name: string;
    countDown: number;
    countTimer: number;
}
export default defineComponent({
    name: "SuccessDialog",
    components: {
        AdView,
    },
    props: {
        url: {
            type: String,
            default: '',
        },

    },
    setup(props, { emit }) {
        const ad = ref<AdItem>()
        const state = reactive<SuccessState>({
            shortUrl: props.url,
            isShow: true,
            name: '',
            countDown: 5,
            countTimer: 0,
        })
        /** 身份认证链接 */
        const shortUrl = ref<string>('')
        shortUrl.value = props.url;
        const onCancel = () => {
            state.isShow = false
            emit('result', {})
        }
        const onClickAuth = () => {
            // 在新窗口中打开 shortUrl
            window.open(shortUrl.value, '_blank');
        }
        const autoCountDown = () => {
            // 每秒减一
            state.countTimer = setInterval(() => {
                state.countDown--
                if (state.countDown <= 0) {
                    clearInterval(state.countTimer);
                    onClickAuth()
                }
            }, 1000)
        }

        onMounted(() => {
            if (state.shortUrl) {
                autoCountDown();
            }
        })
        onUnmounted(() => {
            if (state.countTimer > 0) {
                clearInterval(state.countTimer);
            }
        })
        return {
            state,
            ad,
            onCancel,
            onClickAuth,
        };
    },
})
